import React from 'react';

const Header = () => {
    return ( 
        <div className="jumbotron jumbotron-fluid p-2 text-center bg-danger">
            <div className="container">
                <h1 className="display-3 text-white">Recipe Finder</h1>
            </div>
        </div>
    );
}
 
export default Header;